import React from "react";
import { useLocale } from "../i18n";

export default function Footer() {
  const { locale, t } = useLocale();
  const headingLines = t("newsletter.heading").split("\n");

  return (
    <footer className="mt-32 border-t border-[var(--wr-border)] bg-[var(--wr-surface-2)]" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16 lg:py-24 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-6" data-testid="newsletter-section">
          <p className="font-mono-wr text-[10px] uppercase tracking-[0.2em] text-[var(--wr-ink-2)] mb-3">
            {t("newsletter.kicker")}
          </p>
          <h3 className="font-editorial text-4xl sm:text-5xl leading-[1.02] tracking-tight text-[var(--wr-ink)] mb-6 max-w-lg whitespace-pre-line">
            {headingLines.map((line, i) => (
              <span key={i} className="block">{line}</span>
            ))}
          </h3>
          <div className="max-w-md" data-testid="newsletter-coming-soon">
            <span
              className="inline-flex items-center gap-2 font-mono-wr text-[11px] uppercase tracking-[0.2em] text-[var(--wr-red)] border border-[var(--wr-red)] px-3 py-1.5 mb-4"
              data-testid="newsletter-status"
            >
              <span className="w-1.5 h-1.5 rounded-full bg-[var(--wr-red)]" aria-hidden="true" />
              {t("newsletter.status")}
            </span>
            <p className="text-[15px] leading-relaxed text-[var(--wr-ink-2)]" data-testid="newsletter-body">
              {t("newsletter.body")}
            </p>
          </div>
        </div>
        <div className="lg:col-span-6 grid grid-cols-2 sm:grid-cols-3 gap-8" data-testid="footer-columns">
          <div>
            <p className="font-mono-wr text-[10px] uppercase tracking-[0.2em] text-[var(--wr-ink-2)] mb-3">
              {locale === "en" ? "Explore" : "Explorează"}
            </p>
            <ul className="space-y-2 text-[15px]">
              <li><a href="/regions" className="hover:text-[var(--wr-red)] transition-colors">{t("nav.regions")}</a></li>
              <li><a href="/tools" className="hover:text-[var(--wr-red)] transition-colors">{t("nav.tools")}</a></li>
              <li><a href="/concierge" className="hover:text-[var(--wr-red)] transition-colors">{t("nav.concierge")}</a></li>
            </ul>
          </div>
          <div>
            <p className="font-mono-wr text-[10px] uppercase tracking-[0.2em] text-[var(--wr-ink-2)] mb-3">
              {locale === "en" ? "Company" : "Companie"}
            </p>
            <ul className="space-y-2 text-[15px]">
              <li><a href="/about" className="hover:text-[var(--wr-red)] transition-colors" data-testid="footer-about">{t("nav.about")}</a></li>
              <li><a href="/contact" className="hover:text-[var(--wr-red)] transition-colors" data-testid="footer-contact">{t("nav.contact")}</a></li>
            </ul>
          </div>
          <div className="col-span-2 sm:col-span-1">
            <p className="font-mono-wr text-[10px] uppercase tracking-[0.2em] text-[var(--wr-ink-2)] mb-3">
              {t("legal.heading")}
            </p>
            <ul className="space-y-2 text-[15px]">
              <li><a href="/privacy" className="hover:text-[var(--wr-red)] transition-colors" data-testid="footer-privacy">{t("legal.privacy")}</a></li>
              <li><a href="/terms" className="hover:text-[var(--wr-red)] transition-colors" data-testid="footer-terms">{t("legal.terms")}</a></li>
              <li><a href="/cookies" className="hover:text-[var(--wr-red)] transition-colors" data-testid="footer-cookies">{t("legal.cookies")}</a></li>
            </ul>
          </div>
        </div>
      </div>
      <div className="border-t border-[var(--wr-border)]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="font-editorial text-xl text-[var(--wr-ink)]">
            wow<span className="text-[var(--wr-red)]">romania</span>
            <span className="font-mono-wr text-[10px] uppercase tracking-widest text-[var(--wr-ink-2)] ml-2">/ {t("footer.tagline")}</span>
          </p>
          <p className="font-mono-wr text-[10px] uppercase tracking-widest text-[var(--wr-ink-2)]">
            © 2026 {t("footer.copyright_line")}
          </p>
        </div>
      </div>
    </footer>
  );
}
